export default __webpack_public_path__ + "static/media/mov_bbb.2c92d012.mp4";